// extracted by mini-css-extract-plugin
export default {"inputfield":"DataField_inputfield__7LBta"};